/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-console */
/* eslint-disable prefer-template */
/* eslint-disable radix */

import moduleRegistry from './rfct/module-registry/module-registry';

const config = {
    selectors: {
        module: '.multi-range-slider',
        select: '.rfct-select__select',
    },
};

class MultiRangeSlider {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
    }

    init() {
        const rootElement = this._$rootElement[0];
        const inputLeft = rootElement.querySelector('.multi-range-slider__input--left');
        const inputRight = rootElement.querySelector('.multi-range-slider__input--right');
        const thumbLeft = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--left');
        const thumbRight = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--right');
        const range = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        rootElement.addEventListener('mouseover', function (event) {
            const relX = event.pageX - $(this).offset().left;
            const leftPosition = $(thumbLeft).position();
            const rightPosition = $(thumbRight).position();
            const leftValue = parseFloat(relX) > parseFloat(leftPosition.left) ? parseFloat(relX) - parseFloat(leftPosition.left) : parseFloat(leftPosition.left) - parseFloat(relX);
            const rightValue = parseFloat(relX) > parseFloat(rightPosition.left) ? parseFloat(relX) - parseFloat(rightPosition.left) : parseFloat(rightPosition.left) - parseFloat(relX);
            if (rightValue > leftValue) {
                inputRight.classList.remove('multi-range-slider__input--active');
                inputLeft.classList.add('multi-range-slider__input--active');
            } else {
                inputLeft.classList.remove('multi-range-slider__input--active');
                inputRight.classList.add('multi-range-slider__input--active');
            }
        });

        const leftmin = parseInt(inputLeft.min);
        const leftmax = parseInt(inputLeft.max);
        inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value) - 1);
        const leftpercent = ((inputLeft.value - leftmin) / (leftmax - leftmin)) * 100;
        thumbLeft.style.left = leftpercent + '%';
        range.style.left = leftpercent + '%';
        rootElement.querySelector('.left-value').textContent = inputLeft.value;

        inputLeft.addEventListener('input', () => {
            this._setLeftValue();
        });
        inputLeft.addEventListener('mouseover', function () {
            thumbLeft.classList.add('multi-range-slider__thumb--hover');
        });
        inputLeft.addEventListener('mouseout', function () {
            thumbLeft.classList.remove('multi-range-slider__thumb--hover');
        });
        inputLeft.addEventListener('mousedown', function () {
            thumbLeft.classList.add('multi-range-slider__thumb--active');
        });
        inputLeft.addEventListener('mouseup', function () {
            thumbLeft.classList.remove('multi-range-slider__thumb--active');
        });

        const rightmin = parseInt(inputRight.min);
        const rightmax = parseInt(inputRight.max);
        inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value) + 1);
        const rightpercent = ((inputRight.value - rightmin) / (rightmax - rightmin)) * 100;
        thumbRight.style.right = (100 - rightpercent) + '%';
        range.style.right = (100 - rightpercent) + '%';
        rootElement.querySelector('.right-value').textContent = inputRight.value;

        inputRight.addEventListener('input', () => {
            this._setRightValue();
        });
        inputRight.addEventListener('mouseover', function () {
            thumbRight.classList.add('multi-range-slider__thumb--hover');
        });
        inputRight.addEventListener('mouseout', function () {
            thumbRight.classList.remove('multi-range-slider__thumb--hover');
        });
        inputRight.addEventListener('mousedown', function () {
            thumbRight.classList.add('multi-range-slider__thumb--active');
        });
        inputRight.addEventListener('mouseup', function () {
            thumbRight.classList.remove('multi-range-slider__thumb--active');
        });
    }

    _setLeftValue() {
        const rootElement = this._$rootElement[0];
        const inputLeft = rootElement.querySelector('.multi-range-slider__input--left');
        const inputRight = rootElement.querySelector('.multi-range-slider__input--right');
        const thumbLeft = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--left');
        const range = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        const min = parseInt(inputLeft.min);
        const max = parseInt(inputLeft.max);
        inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value) - 1);
        const percent = ((inputLeft.value - min) / (max - min)) * 100;
        thumbLeft.style.left = percent + '%';
        range.style.left = percent + '%';
        rootElement.querySelector('.left-value').textContent = inputLeft.value;
    }

    _setRightValue() {
        const rootElement = this._$rootElement[0];
        const inputLeft = rootElement.querySelector('.multi-range-slider__input--left');
        const inputRight = rootElement.querySelector('.multi-range-slider__input--right');
        const thumbRight = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__thumb--right');
        const range = rootElement.querySelector('.multi-range-slider__content > .multi-range-slider__range');

        const min = parseInt(inputRight.min);
        const max = parseInt(inputRight.max);
        inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value) + 1);
        const percent = ((inputRight.value - min) / (max - min)) * 100;
        thumbRight.style.right = (100 - percent) + '%';
        range.style.right = (100 - percent) + '%';
        rootElement.querySelector('.right-value').textContent = inputRight.value;
    }
}

moduleRegistry.registerModule('MultiRangeSlider', MultiRangeSlider);
moduleRegistry.autoApplyModule('MultiRangeSlider', config.selectors.module);
